import { render } from "./RegistryMonitorPage.vue?vue&type=template&id=06846ca4&scoped=true"
import script from "./RegistryMonitorPage.vue?vue&type=script&lang=js"
export * from "./RegistryMonitorPage.vue?vue&type=script&lang=js"

import "./RegistryMonitorPage.vue?vue&type=style&index=0&id=06846ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06846ca4"]])

export default __exports__